import React, { useEffect, useCallback, memo } from 'react';
import { reduxConnect } from '../../common'
import { pageVisibility } from '../../common/actions/pageVisibilityActions';
import { pageVisibilityChange } from '../../common/utilities/pageVisibilityChange';

const { hidden, visibilityChange } = pageVisibilityChange();

const mapStoreStateToProps = () => {

    return {

    };
};

const mapDispatchToProps = {
    pageVisibility
};

export const PageVisibilityMonitor = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({pageVisibility }) => {

    const runPageVisibilityAction = useCallback (() => {
        const pageVisibilityStatus = document[hidden] ? false : true;
        pageVisibility(pageVisibilityStatus);
    }, []);

    useEffect(() => {
        if (visibilityChange) {
            document.addEventListener(visibilityChange, runPageVisibilityAction, false);
        }

        return () => {
            if (visibilityChange) {
                document.removeEventListener(visibilityChange, runPageVisibilityAction, false);
            }
        }
    }, []);

    return null;
});
